import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { ILens } from '../types/ILens';
import { IUser } from '../types/IUser';
import { INamedItem } from '../types/resourceParts';

export interface IGetLensesParams extends IGetItemsParams {
}

export interface IGetLensesResult extends IGetItemsResult {
  lenses?: ILens[];
  users?: IUser[];
  projects?: INamedItem[];
  favorites?: string[];
}

export class GetLensesRequest extends Request<IGetLensesParams, IGetLensesResult> {
  constructor(params: IGetLensesParams) {
    super('getLenses', params);
  }
}
